import { useMemo, useEffect } from 'react';
import warn from 'warning';
var prefix = 'react-vertex:';

function log(source) {
  if (typeof source !== 'string') {
    warn(false, "".concat(prefix, " Shader source should be a string!"));
    return '';
  }

  var lines = source.split('\n');

  for (var i = 0; i < lines.length; i++) {
    lines[i] = i + 1 + ': ' + lines[i];
  }

  return lines.join('\n');
}

function useShader(gl, source) {
  var isVertShader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var memoized = useMemo(function () {
    if (source.constructor === WebGLShader) {
      return source;
    }

    var shaderType = isVertShader ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER;
    var shader = gl.createShader(shaderType);
    var precision = 'lowp'; // prettier-ignore

    if (gl.getShaderPrecisionFormat(shaderType, gl.HIGH_FLOAT).precision > 0) {
      precision = 'highp';
    } else if (gl.getShaderPrecisionFormat(shaderType, gl.MEDIUM_FLOAT).precision > 0) {
      precision = 'mediump';
    }

    var prepped = source.replace('<<FLOAT_PRECISION>>', precision);
    gl.shaderSource(shader, prepped);
    gl.compileShader(shader);
    warn(gl.getShaderParameter(shader, gl.COMPILE_STATUS), "".concat(prefix, "\n").concat(gl.getShaderInfoLog(shader), "\n").concat(log(prepped)));
    return shader;
  }, [gl, source, isVertShader]);
  return memoized;
}

export function useProgram(gl, vertSource, fragSource) {
  var vert = useShader(gl, vertSource, true);
  var frag = useShader(gl, fragSource, false);
  var memoized = useMemo(function () {
    var program = gl.createProgram();
    gl.attachShader(program, vert);
    gl.attachShader(program, frag);
    gl.linkProgram(program);
    warn(gl.getProgramParameter(program, gl.LINK_STATUS), "".concat(prefix, " Error creating program"));
    return program;
  }, [gl, vert, frag]);
  useEffect(function () {
    return function () {
      return gl.deleteProgram(memoized);
    };
  }, [gl, memoized]);
  gl.useProgram(memoized);
  return memoized;
}
export function useProgramUniforms(gl, program) {
  var memoized = useMemo(function () {
    var uniforms = {};
    var uniformCount = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);

    for (var i = 0; i < uniformCount; i++) {
      var name = gl.getActiveUniform(program, i).name;
      uniforms[name] = gl.getUniformLocation(program, name);
    }

    return uniforms;
  }, [gl, program]);
  return memoized;
}